var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 7.61814H6.11127V17.0626H3.3335V7.61814ZM4.71405 6.50703H4.6985C3.86961 6.50703 3.3335 5.88925 3.3335 5.11758C3.3335 4.32925 3.88627 3.72925 4.73016 3.72925C5.57516 3.72925 6.09572 4.32925 6.11127 5.11758C6.11127 5.88869 5.57516 6.50703 4.71405 6.50703ZM16.6668 17.0626H13.8891V12.0076C13.8891 10.7865 13.2085 9.95314 12.1157 9.95314C11.2818 9.95314 10.8307 10.5154 10.6118 11.0587C10.5318 11.2531 10.5557 11.7909 10.5557 12.0626V17.0626H7.77794V7.61814H10.5557V9.07147C10.9563 8.45147 11.5835 7.61814 13.1879 7.61814C15.1757 7.61814 16.6663 8.86814 16.6663 11.6592L16.6668 17.0626Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ad0014f9972f6b571392b304f61d5d48.svg";
export { ForwardRef as ReactComponent };